import autosize from 'autosize';

export default (container?: HTMLElement) => {
    autosize((container ?? document).querySelectorAll('textarea'));
};
